export default "__VITE_ASSET__DK$Q$q0___"